export default __webpack_public_path__ + "static/media/dockerPull.c1316710.svg";